/**
 * Outlined inputs hide the default fieldset in favor of a root border; shrunk
 * labels need a solid backdrop so the border does not cut through label text.
 * Align focused label color with neutral slate (avoids primary pink on fields).
 */
import colors from "assets/theme/base/colors";
import pxToRem from "assets/theme/functions/pxToRem";

const { white, dark, error } = colors;

const inputLabel = {
  styleOverrides: {
    root: {
      "&.MuiInputLabel-outlined": {
        "&.MuiInputLabel-shrink": {
          backgroundColor: white.main,
          paddingLeft: pxToRem(4),
          paddingRight: pxToRem(4),
        },
      },
      "&.Mui-focused": {
        color: `${dark.main} !important`,
      },
      "&.Mui-error": {
        color: `${error.main} !important`,
      },
    },
  },
};

export default inputLabel;
